import { ecsApi } from '@services';
import { GetEpiProductCategoriesResponse, GetEpiProductsByCategoryResponse } from './epiProducts.types';

export const epiProductsApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getEpiProductCategories: builder.mutation<GetEpiProductCategoriesResponse, void>({
            query: () => ({
                url: '/products-epi/categories',
                method: 'GET'
            })
        }),
        getEpiProductsByCategory: builder.mutation<GetEpiProductsByCategoryResponse, string>({
            query: (categoryId) => ({
                url: `/products-epi?id_category=${categoryId}`,
                method: 'GET'
            })
        })
    })
});

export const { useGetEpiProductCategoriesMutation, useGetEpiProductsByCategoryMutation } = epiProductsApi;
